import {createPortal} from 'react-dom';
import {useMemo} from 'react';

const getContainer = container => (
    typeof container === 'string' ? document.getElementById(container) : container
);

const Portal = ({container, children}) => {
    const node = useMemo(() => getContainer(container), [container]);

    return node && createPortal(children, node);
};

export default Portal;
